import { render, staticRenderFns } from "./SimulatorPreview.vue?vue&type=template&id=0ddfbc03&"
import script from "./SimulatorPreview.vue?vue&type=script&lang=js&"
export * from "./SimulatorPreview.vue?vue&type=script&lang=js&"
import style0 from "./SimulatorPreview.vue?vue&type=style&index=0&id=0ddfbc03&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports